import { matchPath } from "react-router";

/**
 * Maps a pathname to one of the main navigation entries (Dashboard,
 * Sponsoringen, Balsponsoren, Leads, Bedrijven, Contactpersonen), or false
 * when the current route belongs to none of them (settings, profile, users,
 * ...). The mobile navigation groups the three sponsoring overviews under one
 * tab (see SPONSORING_TABS).
 */
export const getCurrentTab = (pathname: string): string | false => {
  if (matchPath("/", pathname)) return "/";
  if (matchPath("/sponsorings/*", pathname)) return "/sponsorings";
  if (matchPath("/balsponsoren/*", pathname)) return "/balsponsoren";
  if (matchPath("/leads/*", pathname)) return "/leads";
  if (matchPath("/companies/*", pathname)) return "/companies";
  if (matchPath("/contacts/*", pathname)) return "/contacts";
  return false;
};

/** The tabs that all belong to the sponsorings section */
export const SPONSORING_TABS = ["/sponsorings", "/balsponsoren", "/leads"];
